export default "__VITE_ASSET__5d33de7c__"